import { fetchApi } from '../utils/fetchApi'

// import { createRequest } from './createRequest'

export const facmList = ({ params }) => fetchApi({
  body: params,
  path: '/facm/list',
})

export const facmCancel = ({ params }) => fetchApi({
  body: params,
  path: '/facm/cancel',
})
